// extracted by mini-css-extract-plugin
export default {"clientCard":"ClientTestimonialCard_clientCard__-o2QR","active":"ClientTestimonialCard_active__N+SMr"};